import type { FunctionComponent } from "react";

import styles from "./Checkbox.module.scss";

interface Props {
	checked: boolean;
	title: string;
	onChange: () => void;
	disabled?: boolean;
}

export const Checkbox: FunctionComponent<Props> = ({
	checked,
	title,
	onChange,
	disabled,
}) => {
	return (
		<label className={styles.checkboxLabel}>
			<input
				type="checkbox"
				checked={checked}
				onChange={onChange}
				disabled={disabled}
			/>
			<span>{title}</span>
		</label>
	);
};
